(function() {
  const header = document.querySelector('.header');
  const hamburger = document.querySelector('.hamburger');

  let scrollPosition = 0;
  let ticking = false;

  const documentOnScroll = (scrollPosition) => {
    if (scrollPosition > 0) {
      header.classList.add('scrolled');
    }
    else {
      header.classList.remove('scrolled');
    }
  };

  document.addEventListener('scroll', () => {
    scrollPosition = window.scrollY;

    if (ticking) {
      return;
    }

    window.requestAnimationFrame(() => {
      documentOnScroll(scrollPosition);
      ticking = false;
    });

    ticking = true;

  }, {passive: true});

  const hideOnClickOutside = element => {
    const outsideClickListener = event => {
      if (! element.contains(event.target)) {
        document.body.classList.remove('menu-open');
      }
    }

    document.addEventListener('click', outsideClickListener)
  };

  hideOnClickOutside(hamburger);

  hamburger.addEventListener('click', event => {
    document.body.classList.toggle('menu-open');
  });
})();
